<template>
  <div id="contentsWrap">
    <PCtop v-if="device==='pc'"></PCtop>
    <Loading v-if="device==='sp' && state === 'loading'" ref="loading" @loadComplete="onLoadComplete"></Loading>
    <Cover v-if="device==='sp' && state === 'cover'" @selectChara="onSelectChara"></Cover>
    <Top v-if="device==='sp' && state === 'top'" @selectChara="onSelectChara"></Top>
    <Story v-if="device==='sp' && state === 'story'" :storyData="currentStoryData" @changeState="onChangeState"></Story>
  </div>
</template>


<script>
import _$ from 'jquery'
// impojort _ from 'lodash'

import PCtop from '@/view/PCtop.vue'
import Loading from '@/view/Loading.vue'
import Cover from '@/view/Cover.vue'
import Top from '@/view/Top.vue'
import Story from '@/view/Story.vue'

import data_shirogane from '@/assets/json/shirogane.json'
import data_iino from '@/assets/json/iino.json'
import data_kaguya from '@/assets/json/kaguya.json'
import data_ishigami from '@/assets/json/ishigami.json'
import data_hayasaka from '@/assets/json/hayasaka.json'
import data_tsubame from '@/assets/json/tsubame.json'
import data_fujiwara from '@/assets/json/fujiwara.json'
import data_shijo from '@/assets/json/shijo.json'

import loadimgs from '@/assets/json/loadimgs.json'

export default {
  components: {
    PCtop,
    Loading,
    Cover,
    Top,
    Story
  },
  data() {
    return {
      storyData: {
        shirogane: data_shirogane,
        iino: data_iino,
        kaguya: data_kaguya,
        ishigami: data_ishigami,
        hayasaka: data_hayasaka,
        tsubame: data_tsubame,
        fujiwara: data_fujiwara,
        shijo: data_shijo
      },
      currentStoryData: null,

      device: null,
      state: 'loading',
      perNum: 0,
      timerCount: 0,
      progressCount: 0,
      currentChara: null,

      storageData: null,
      startState: null,

      images: loadimgs,
      loadImgRate: 0
    }
  },
  created() {
    if(navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)){
      this.device = 'sp'
    } else {
      this.device = 'pc'
    }

    // console.log("*** device", this.device)

    if(this.device === 'sp'){
      this.timer = setInterval(function(){
        this.timerCount++
        this.progressCount = this.timerCount / 18 * 90 + this.loadImgRate * .1
        if(this.timerCount >= 18){
          clearInterval(this.timer)
        }
      }.bind(this), 666)

      this.loadCommonImage()
    }
  },
  watch: {
    progressCount(newVal){
      this.$refs.loading.progressCount = newVal
    },
    state(newVal){
      switch(newVal){
        case 'top':
          this.currentStoryData = null
          this.currentChara = null
      }
    }
  },
  mounted() {
    if(this.device === 'sp'){
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      // -----------------------------------------------------------------

      this.getLocalStorage()

      // スタートするページ
      if(this.storageData.startState.val){
        clearInterval(this.timer)
        switch(this.storageData.startState.val){
          case 'top':
          case 'top_fr_trial':
            // TOPから
            this.state = 'top'
            break;
          default:
            // 各キャラトップから
            this.onSelectChara(this.storageData.startState.val)
            this.storageData.startState.val = null
            this.setLocalStorage()
        }
      }
    } else {
      _$('#contentsWrap').addClass('pc')
    }
  },
  methods: {
    // onProgress() {
    //   this.progressCount++
    //   // console.log("***pr");
    // },
    onLoadComplete() {
      // ローディング終了 → トップへ
      this.onChangeState('cover')
    },
    onSelectChara(val) {
      // キャラ選択
      this.currentChara = val
      this.currentStoryData = this.storyData[val]
      this.onChangeState('story')
    },
    onChangeState(val){
      this.state = val
    },
    saveStartPos(chara, scene){
      // BAD ENDの状況を保存
      // console.log("save / ", chara, scene)
      this.storageData.storyPos[chara] = scene
      this.setLocalStorage()
    },
    saveClearState(chara){
      // CLEARの状況を保存
      // console.log("clear save / ", chara)
      // if(chara !== 'fujiwara'){
        this.storageData.clearState[chara] = true
      // }
      this.storageData.storyPos[chara] = null
      this.setLocalStorage()
    },
    getLocalStorage(){
      this.storageData = JSON.parse(localStorage.getItem('yj_kaguya22__dataObj'))
      if(!this.storageData){
        this.storageData = {
          clearState:{
            shirogane: null,
            iino: null,
            kaguya: null,
            ishigami: null,
            hayasaka: null,
            tsubame: null,
            fujiwara: null,
            shijo: null,
          },
          storyPos: {
            shirogane: null,
            iino: null,
            kaguya: null,
            ishigami: null,
            hayasaka: null,
            tsubame: null,
            fujiwara: null,
            shijo: null
          },
          share: {
            shirogane: null,
            iino: null,
            kaguya: null,
            ishigami: null,
            hayasaka: null,
            tsubame: null,
            fujiwara: null,
            shijo: null
          },
          startState: {
            val: null
          }
        }
        this.setLocalStorage()
      }
    },
    setLocalStorage(){
      localStorage.setItem('yj_kaguya22__dataObj', JSON.stringify(this.storageData))
    },
    loadCommonImage(){
      let _this = this,
          imgsNum = this.images.length,
          countNum = 0

      this.images.forEach(function(url){
        let img = new Image();
        img.src = url;

        img.addEventListener('load', function(){
          countNum++
          _this.loadImgRate = Math.round(countNum / imgsNum * 100)
        })
      });
    }
  }
}
</script>


<style lang="scss">
  @import "./css/reset.css";
  @import url('https://fonts.googleapis.com/css2?family=DotGothic16&display=swap');

  #contentsWrap {
      background-color: #000;
      color: #fff;
      font-family: 'DotGothic16', sans-serif;
      font-size: toVW(26);
      width: 100vw;
      height: 100vh;
      height: calc(var(--vh, 1vh) * 100);
      position: relative;
  }

  @media screen and (orientation: landscape) {
    #contentsWrap:not(.pc) {
      height: 176.5vw;
    }
  }
</style>
